module.exports = __webpack_public_path__ + "media/images/icons/error-eb457ddd8fc91885b8b314ddd7259115.svg";